import LegendIcon from '~/shared/assets/icons/line-chart-legend.svg';

export default function Legend({ hexColor, title }: { hexColor: string; title?: string }) {
  return (
    <div className="flex gap-[8px] h-fit items-center">
      <LegendIcon className="w-[24px] h-[24px]" style={{ fill: hexColor }} />
      <div className="text-[11px] leading-[16px] font-medium text-[#949EAC] tracking-[-0.397px]">
        {title}
      </div>
    </div>
  );
}
